import { type AxiosInstance } from "axios";
import { REGISTRY_CHANGE_ALERTS_ENDPOINT } from "@/features/registryChangeAlert/api/GetRegistryChangeAlertsAPI";
import { FETCH_ALL_PAGE_SIZE } from "@/features/registryChangeAlert/utils/constants";
import type {
  GetRegistryChangeAlertsAPIResponse,
  RegistryChangeAlertEntity,
} from "@/features/registryChangeAlert/types";

/**
 * 指定した ID の変動アラートのうち、今も表示対象の分を取得する（選んだ物件を取得する直前の読み直し用）。
 * 1 回の取得上限ごとに分けて読む。表示対象でなくなった ID は結果に含まれない。
 * @param {AxiosInstance} apiClient JWT 認証付き apiClient
 * @param {readonly number[]} ids アラート ID
 * @returns {Promise<RegistryChangeAlertEntity[]>}
 */
export const FetchRegistryChangeAlertsByIdsAPI = async (
  apiClient: AxiosInstance,
  ids: readonly number[]
): Promise<RegistryChangeAlertEntity[]> => {
  const alerts: RegistryChangeAlertEntity[] = [];
  for (let i = 0; i < ids.length; i += FETCH_ALL_PAGE_SIZE) {
    const { data } = await apiClient.get<GetRegistryChangeAlertsAPIResponse>(
      REGISTRY_CHANGE_ALERTS_ENDPOINT,
      {
        params: {
          ids: ids.slice(i, i + FETCH_ALL_PAGE_SIZE).join(","),
          pageSize: FETCH_ALL_PAGE_SIZE,
        },
      }
    );
    alerts.push(...data.items);
  }
  return alerts;
};
